/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */

import '../../components/carousel/carousel.js'
$(function () {
    function loadStatisticsGrpahs(elem) {
        let filledElement = elem.find('.full').eq(0);
        let partFillHost = parseInt(elem.siblings('.percent-host').eq(0).html());
        let partFillGuest = parseInt(elem.siblings('.percent-guest').eq(0).html());
        let whole = partFillHost + partFillGuest;
        let percent;
        if (elem.hasClass('graph-host')) {
            percent = parseInt((partFillHost / whole) * 100);
        } else if (elem.hasClass('graph-guest')) {
            percent = parseInt((partFillGuest / whole) * 100);
        };

        filledElement.css('width', percent + '%');

    }

    function initRankingSchemes(context) {
        const $context = context ? $(context) : $(document);
        console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<INIT>>>>>>>>>>>',$context);

        $context.find('.ls-ranking-table.scheme').addBack('.ls-ranking-table.scheme').each(function () {
            if ($(this).data('schemeInitialized')) {
                return;
            }

            $(this).data('schemeInitialized', true);

            let currentIndex;
            const isWorldcup2026 = $('body').data('page') === 'worldcup2026' || $('body').hasClass('matchhub_page');

            if (!currentIndex > 0) {
                if (isWorldcup2026) {
                   const serverDateStr = $('body').data('setdate');
                    const currentDate = serverDateStr ? new Date(serverDateStr + 'T00:00:00') : new Date();
                    const thresholdDate = new Date('2026-07-08T00:00:00'); 

                    $(this).find('.subhead-row > .round, .scheme-block .round').removeClass('current current-dt'); 

                    if (currentDate >= thresholdDate) {
                        $(this).find('.subhead-row > .round.fin-4, .scheme-block .round.fin-4').addClass('current');
                        const roundOf4Index = $(this).find('.scheme-block .round.fin-4').first().index();
                        currentIndex = roundOf4Index > -1 ? roundOf4Index : 3; 

                        $(this).find('.subhead-row > .round').slice(currentIndex + 1, currentIndex + 3).addClass('current-dt');
                        $(this).find('.scheme-block .round').slice(currentIndex + 1, currentIndex + 3).addClass('current-dt');
                    } else {
                        $(this).find('.subhead-row > .round.fin-16, .scheme-block .round.fin-16').addClass('current');
                        $(this).find('.subhead-row > .round.fin-8, .scheme-block .round.fin-8').addClass('current-dt');
                        $(this).find('.subhead-row > .round.fin-4, .scheme-block .round.fin-4').addClass('current-dt');
                        const roundOf16Index = $(this).find('.scheme-block .round.fin-16').first().index();
                        currentIndex = roundOf16Index > -1 ? roundOf16Index : 3; 
                    }
                 } else {
                    currentIndex = 1;
                }
            }

            if (!isWorldcup2026 || !$(this).find('.scheme-block .round.fin-16').length) {
                $(this).find('.subhead-row > .round').eq(currentIndex).addClass('current');
                $(this).find('.scheme-block .round').eq(currentIndex).addClass('current');
                $(this).find('.subhead-row > .round').slice(currentIndex + 1, currentIndex + 3).addClass('current-dt');
                $(this).find('.scheme-block .round').slice(currentIndex + 1, currentIndex + 3).addClass('current-dt');
            }

            if ($('.scheme-block .round').eq(-1).is('.current, .current-dt')) {
                $('.scheme .slide-right.dt').addClass('inactive');
                if ($('.scheme-block .round').eq(-1).hasClass('current')) {
                    $('.scheme .slide-right.mb').addClass('inactive');
                    $('.subhead-row > .round').eq(-2).addClass('current-dt');
                    $('.subhead-row > .round').eq(-3).addClass('current-dt');
                    $('.scheme-block .round').eq(-2).addClass('current-dt');
                    $('.scheme-block .round').eq(-3).addClass('current-dt');
                } else {
                    $('.scheme .slide-right.mb').removeClass('inactive');
                }

                if ($('.scheme-block .round').eq(-2).hasClass('current')) {
                    $('.subhead-row > .round').eq(-3).addClass('current-dt');
                    $('.scheme-block .round').eq(-3).addClass('current-dt');
                }

            } else {
                $('.scheme .slide-right.dt, .scheme .slide-right.mb').removeClass('inactive');
            }

            if ($('.scheme-block .round').eq(0).is('.current, .current-dt')) {
                $('.scheme .slide-left').addClass('inactive');
            } else {
                $('.scheme .slide-left').removeClass('inactive');
            }
        });
    }

    initRankingSchemes(document);

    document.addEventListener('matchHub:rankingInfoLoaded', function (event) {
        const elem = event.detail.elem;
        initRankingSchemes(elem);
    });

    $('body').on('click', '.scheme .slide-left:not(.inactive), .scheme .slide-right:not(.inactive)', schemeMove);

    function schemeMove(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        //console.log(e.type, e);
        let dir, step, initIndex, endIndex, maxIndex;
        let stepMb = 1;
        let stepDt = 2;
        initIndex = $('.scheme-block .round').index($('.scheme-block .round.current'));

        if ($(this).hasClass('dt')) {
            step = stepDt;
            maxIndex = $('.scheme-block .round').index($('.scheme-block .round').eq(-3));
            //console.log($(this).hasClass('dt'));
        } else {
            step = stepMb;
            maxIndex = $('.scheme-block .round').index($('.scheme-block .round').eq(-1));
            //console.log($(this).hasClass('dt'));
        }

        if ($(this).hasClass('slide-left')) {
            dir = -1;
        } else if ($(this).hasClass('slide-right')) {
            dir = 1;
        }

        endIndex = initIndex + dir * step;
        if (endIndex < 0) {
            endIndex = 0;
        }
        if (endIndex > maxIndex) {
            endIndex = maxIndex;
        }

        $('.subhead-row > .round, .scheme-block .round').removeClass('current current-dt');
        $('.subhead-row > .round').eq(endIndex).addClass('current');
        $('.scheme-block .round').eq(endIndex).addClass('current');
        $('.subhead-row > .round').slice(endIndex + 1, endIndex + 3).addClass('current-dt');
        $('.scheme-block .round').slice(endIndex + 1, endIndex + 3).addClass('current-dt');

        if ($('.scheme-block .round').eq(-1).is('.current, .current-dt')) {
            $('.scheme .slide-right.dt').addClass('inactive');
            if ($('.scheme-block .round').eq(-1).hasClass('current')) {
                $('.scheme .slide-right.mb').addClass('inactive');
            } else {
                $('.scheme .slide-right.mb').removeClass('inactive');
            }
        } else {
            $('.scheme .slide-right.dt').removeClass('inactive');
        }

        if ($('.scheme-block .round').eq(0).is('.current, .current-dt')) {
            $('.scheme .slide-left').addClass('inactive');
        } else {
            $('.scheme .slide-left').removeClass('inactive');
        }

        localStorage.setItem('scheme-' + $(this).closest('.ls-ranking-table.scheme').attr('data-id'), endIndex);
    }
})